import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { Context } from "./classes/context";
import "./ImgEditor.css";
import Accordion from "react-bootstrap/Accordion";
import { IdleTool } from "./img-editor-components/toolprops";
import { CropProps, CropToolCnvControls } from "./classes/cropTool";
import { RotProps, RotToolCnvControls } from "./classes/rotTool";
import { PerpProps, PerpToolCnvControls } from "./classes/perpTool";
import { FilterProps } from "./classes/median";
import { ThresholdProps } from "./classes/threshold";
import { ScaleProps, ScaleCnvControls } from "./classes/scale";
import * as RB from "react-bootstrap";
import { Card } from "react-bootstrap";
import imgEditorStore from "./redux/store";
import { Provider, useSelector, useStore } from "react-redux";
export const ImgEditorToolBar = (props) => {
    const perpArgs = props.perpArgs;
    const [activeTool, setActiveTool] = useState(null);
    const [activeKey, setActiveKey] = useState(null);

    const toolList = props.toolCtrlList;
    const unsub = useRef(null);
    const store = useStore();
    /**@type {Context} */
    let ctx = props.context;
    /**@type {CropToolCnvControls} */
    const cropCtrl = toolList.cropCtrl;
    /**@type {RotToolCnvControls} */
    const rotCtrl = toolList.rotCtrl;
    /**@type {PerpToolCnvControls} */
    const perpCtrl = toolList.perpCtrl;
    /**@type {ScaleCnvControls} */
    const scaleCtrl = toolList.scaleCtrl;
    const selectHandler = (event) => {
        setActiveKey(event);
        if (ctx.offScrCnv.width === 0) {
            return;
        }
        ctx.unbindCnvControls();
        if (unsub.current !== null) {
            unsub.current();
        }
        ctx.updateImage();
        ctx.curM = new DOMMatrix([1, 0, 0, 1, 0, 0]);
        switch (event) {
            //crop
            case "0":
                setActiveTool("crop");
                ctx.bindCnvControls(cropCtrl.listeners, cropCtrl.updateImage);
                unsub.current = store.subscribe(cropCtrl.updateImage);
                cropCtrl.initState();
                cropCtrl.updateImage();
                break;
            //rotation
            case "1":
                setActiveTool("rotation");
                ctx.bindCnvControls(rotCtrl.listeners, rotCtrl.updateImage);
                unsub.current = store.subscribe(rotCtrl.updateImage);
                rotCtrl.initState();
                rotCtrl.updateImage();
                break;
            //perspective
            case "2":
                setActiveTool("perspective");
                ctx.bindCnvControls(perpCtrl.listeners, perpCtrl.updateImage);
                unsub.current = store.subscribe(perpCtrl.updateImage);
                perpCtrl.initState();
                perpCtrl.updateImage();
                break;
            //filter
            case "3":
                setActiveTool("filter");
                break;
            //idle
            case "4":
                setActiveTool(null);
                break;
            //threshold
            case "5":
                setActiveTool("threshold");
                break;
            case "6":
                setActiveTool("scale");
                ctx.bindCnvControls(scaleCtrl.listeners, scaleCtrl.updateImage);
                unsub.current = store.subscribe(scaleCtrl.delayedUpdateImage);
                scaleCtrl.initState();
                // perpCtrl.updateImage();
                break;
            default:
                setActiveTool(null);
                ctx.updateImage();
                break;
        }
    };
    useEffect(() => {
        setActiveKey(null);
    }, [props.image]);
    return (
        <div className="toolbar">
            <RB.Accordion
                activeKey={activeKey}
                id="tools-accord"
                style={{ width: "100%" }}
                onSelect={selectHandler}
            >
                <Card style={{ display: "None" }}>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-idle"
                        as={Card.Header}
                        eventKey="4"
                    >
                        Idle
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="4">
                        <Card.Body>
                            <IdleTool />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-crop"
                        as={Card.Header}
                        eventKey="0"
                    >
                        Обрезка
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <CropProps
                                isActive={activeTool === "crop"}
                                context={props.context}
                            />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-rotation"
                        as={Card.Header}
                        eventKey="1"
                    >
                        Поворот
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            <RotProps context={props.context} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-perspective"
                        as={Card.Header}
                        eventKey="2"
                    >
                        Коррекция перспективы
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            <PerpProps
                                context={props.context}
                                args={perpArgs}
                            />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-filter"
                        as={Card.Header}
                        eventKey="3"
                    >
                        Медианный фильтр
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="3">
                        <Card.Body>
                            <FilterProps context={props.context} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-threshold"
                        as={Card.Header}
                        eventKey="5"
                    >
                        Бинаризация
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="5">
                        <Card.Body>
                            <ThresholdProps context={props.context} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card>
                    <Accordion.Toggle
                        className="toolitem"
                        id="toolitem-threshold"
                        as={Card.Header}
                        eventKey="6"
                    >
                        Масштабирование
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="6">
                        <Card.Body>
                            <ScaleProps context={props.context} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </RB.Accordion>
        </div>
    );
};
export const ImgEditorWrapper = (props) => {
    const perpArgs = props.perpArgs;
    /**@type {Context} */
    let ctx = props.context;

    const image = props.image;
    // ctx.origImg.src = image;

    // ctx.origImg.src = props.origImage;
    const store = useStore();
    const toolCtrlList = useRef({
        cropCtrl: CropToolCnvControls.getInstance(ctx, store),
        rotCtrl: RotToolCnvControls.getInstance(ctx, store),
        perpCtrl: PerpToolCnvControls.getInstance(ctx, store),
        scaleCtrl: ScaleCnvControls.getInstance(ctx, store),
    });
    const wrapperRef = useRef(null);
    const handleShortcut = useCallback(
        /**
         *
         * @param {KeyboardEvent} event
         */
        (event) => {
            // event.preventDefault();
            let isFocusInsideWrapper = wrapperRef.current.contains(
                document.activeElement
            );
            let isInputFocused =
                document.activeElement.matches(".wrapper input");
            switch (event.code) {
                case "KeyZ":
                    // Ctrl+Z handle
                    if (
                        isFocusInsideWrapper &&
                        !isInputFocused &&
                        event.ctrlKey
                    ) {
                        if (event.shiftKey) ctx.redo();
                        else ctx.undo();
                        event.preventDefault();
                    }
                    break;
                case "KeyY":
                    if (
                        isFocusInsideWrapper &&
                        !isInputFocused &&
                        event.ctrlKey
                    ) {
                        ctx.redo();
                        event.preventDefault();
                    }
                    break;
            }
        },
        []
    );
    // We need useEffect hook beacause ctx.initAll must be executed after all
    // elements are rendered
    useEffect(() => {
        document.addEventListener("keydown", handleShortcut);
        return () => {
            document.removeEventListener("keydown", handleShortcut);
        };
    }, [handleShortcut]);
    useEffect(() => {
        ctx.initAll(window);
        ctx.updateImage();
    }, []);
    /**
     *
     * @param {HTMLEvent} event
     */

    return (
        <div className="wrapper" ref={wrapperRef} tabIndex={0}>
            {/* origImage={props.origImage} */}
            <ImgEditorToolBar
                context={ctx}
                toolCtrlList={toolCtrlList.current}
                perpArgs={perpArgs}
                image={image}
            />
            <div className="work-canvas">
                <canvas id="img-editor-view-canvas"></canvas>
            </div>
            <div className="work-footer">
                <div className="footer-section" id="footer-label-section">
                    <label
                        className="footer-label view-coord-label"
                        id="view-x"
                    >
                        View X: 0
                    </label>
                    <label
                        className="footer-label view-coord-label"
                        id="view-y"
                    >
                        View Y: 0
                    </label>
                    <label
                        className="footer-label image-coord-label"
                        id="image-x"
                    >
                        Координата X: 0
                    </label>
                    <label
                        className="footer-label image-coord-label"
                        id="image-y"
                    >
                        Координата Y: 0
                    </label>
                </div>
                <div className="footer-section" id="footer-button-section">
                    <input
                        type="file"
                        accept=".png, .jpeg, .jpg"
                        id="load-btn"
                    />
                    <RB.Button
                        className="footer-button"
                        id="undo-btn"
                        size="sm"
                        title="Отменить последнее преобразование (Ctrl + Z)"
                    >
                        <FontAwesomeIcon icon={faUndoAlt} />
                    </RB.Button>
                    <RB.Button
                        className="footer-button"
                        id="redo-btn"
                        size="sm"
                        title="Применить отмененное преобразование (Ctrl + Y)"
                    >
                        <FontAwesomeIcon icon={faRedoAlt} />
                    </RB.Button>
                    <RB.Button
                        className="footer-button"
                        id="reset-img-btn"
                        size="sm"
                    >
                        Сброс изменений
                    </RB.Button>
                    <RB.Button
                        className="footer-button"
                        id="save-btn"
                        size="sm"
                    >
                        Скачать изображение
                    </RB.Button>
                </div>
            </div>
        </div>
    );
};

export const ImgEditor = function ImgEditor(props) {
    return (
        <Provider store={imgEditorStore}>
            <ImgEditorWrapper {...props} />
        </Provider>
    );
};
